import { render } from "./UserReviewDropdown.vue?vue&type=template&id=55d4caae"
import script from "./UserReviewDropdown.vue?vue&type=script&lang=js"
export * from "./UserReviewDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__